import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.sales.status');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-sales-status',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.sales.status/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

.status-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}
.page-header .back-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--pos-radius, 6px);
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-header .back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.page-header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.page-body {
  flex: 1;
  overflow: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-card {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
}
.section-card.full-width {
  width: 100%;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--pos-accent);
}

.filter-row {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--pos-text-dim);
  cursor: pointer;
}
.radio-label input {
  accent-color: var(--pos-accent);
}

.top-row, .mid-row {
  display: flex;
  gap: 12px;
}
.top-row .section-card, .mid-row .section-card {
  flex: 1;
  min-width: 0;
}

.table-wrap {
  flex: 1;
  overflow: auto;
  min-height: 0;
}

.pos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.pos-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
.pos-table thead th {
  padding: 7px 6px;
  background: var(--pos-table-header, var(--pos-bg));
  border-bottom: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}
.pos-table tbody tr td {
  padding: 6px;
  border-bottom: 1px solid var(--pos-border);
  border-bottom-color: rgba(128, 128, 128, 0.08);
  text-align: center;
  white-space: nowrap;
}
.pos-table tbody tr.subtotal-row {
  background: var(--pos-hover);
}
.pos-table tbody tr.subtotal-row td {
  font-weight: 600;
  color: var(--pos-accent);
}
.pos-table tbody tr.grand-row {
  background: var(--pos-selected);
}
.pos-table tbody tr.grand-row td {
  font-weight: 700;
  color: var(--pos-text);
  font-size: 13px;
}
.pos-table .text-right {
  text-align: right;
}
.pos-table .text-center {
  text-align: center;
}

.summary-table thead th {
  font-size: 11px;
}
.summary-table tbody td {
  font-size: 12px;
}

.grand-total-row {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  padding: 4px 12px;
}`],
})
export class PagePosSalesStatusComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    // ─── 매장 매출내역 ───
    public storeFilter: string = '전체';
    public storeItems: any[] = [];

    // ─── 배달 매출내역 ───
    public deliveryFilter: string = '전체';
    public deliveryItems: any[] = [];

    // ─── 매장 판매현황 ───
    public storeSummary: any[] = [];
    public storeSubtotal = { customers: 0, count: 0, amount: 0 };

    // ─── 배달 판매현황 ───
    public deliverySummary: any[] = [];
    public deliverySubtotal = { customers: 0, count: 0, amount: 0 };
    public grandTotal = { customers: 0, count: 0, amount: 0 };

    // ─── 결제수단별 ───
    public paymentType: string = '영수건별';
    public paymentItems: any[] = [];
    public paymentTotal = { count: 0, amount: 0 };

    public async ngOnInit() {
        await this.service.init();
        await this.loadStatus();
        await this.service.render();
    }

    public async loadStatus() {
        let res = await wiz.call("load_status", {});
        if (res.code === 200) {
            this.storeItems = res.data.storeItems || [];
            this.storeSummary = res.data.storeSummary || [];
            this.paymentItems = res.data.paymentItems || [];

            // 소계 계산
            let sc = 0, sa = 0;
            for (let s of this.storeSummary) { sc += s.count; sa += s.amount; }
            this.storeSubtotal = { customers: sc, count: sc, amount: sa };
            this.grandTotal = { customers: sc, count: sc, amount: sa };

            let pc = 0, pa = 0;
            for (let p of this.paymentItems) { pc += p.count; pa += p.amount; }
            this.paymentTotal = { count: pc, amount: pa };
        }
    }

    public goBack() { this.service.href('/pos/sales'); }

    public async setStoreFilter(f: string) { this.storeFilter = f; await this.service.render(); }
    public async setDeliveryFilter(f: string) { this.deliveryFilter = f; await this.service.render(); }
    public async setPaymentType(t: string) { this.paymentType = t; await this.service.render(); }

    public formatCurrency(v: number): string { return (v || 0).toLocaleString(); }
}

export default PagePosSalesStatusComponent;